// extracted by mini-css-extract-plugin
export var addButton = "_f7-0";
export var border = "_f7-8";
export var check = "_f7-h";
export var danger = "_f7-6";
export var dropdownContainer = "_f7-1";
export var editModalBody = "_f7-j";
export var footerContainer = "_f7-i";
export var fullWidth = "_f7-a";
export var hide = "_f7-9";
export var icon = "_f7-3";
export var input = "_f7-7";
export var inputFlex = "_f7-b";
export var inputWrapper = "_f7-c";
export var manualFocus = "_f7-5";
export var optionButton = "_f7-4";
export var pillWrapper = "_f7-e";
export var pointer = "_f7-2";
export var showOverflow = "_f7-f";
export var tagsFlex = "_f7-d";
export var xButton = "_f7-g";